<template>
  <div class="rn-contact-area rn-section-gap" id="contact">
    <div class="contact-form-notin">
      <v-container>
        <v-row>
          <v-col lg="6" md="6" sm="12" cols="12" :order="control.ImagenPosicion === 1 ? 2 : 1">
            <div class="text-left mb--30 titulo-form-notin">
              <h2 class="heading-title">{{ control.Titulo.Texto }}</h2>
              <p class="description">
                {{ control.Descripcion.Texto }}
              </p>
            </div>
            <div class="form-wrapper fields-form-notin">
              <form v-if="!enviado">
                <fieldset name="Formulario Contacto" style="border:0">
                  <div>
                    <div class="input-error">
                      <div v-for="keyError, errorindex in Object.keys(errors)" v-bind:key="errorindex">{{
                errors[keyError]
              }}
                      </div>
                    </div>
                    <label for="name" class="description text-capitalize" v-if="control.Fields.Name">
                      {{ $t('nombre') }}{{ control.Fields.ForceName ? ' *' : '' }}</label>
                    <input id="name" name="name" v-if="control.Fields.Name" type="text" v-model="form.name"
                      :placeholder="$t('nombre')" />
                    <span class="input-error" v-if="control.Fields.Name">{{ errors.name }}</span>


                    <label for="email" class="description text-capitalize" v-if="control.Fields.Email">
                      {{ $t('email') }}{{ control.Fields.ForceEmail ? ' *' : '' }}</label>
                    <input id="email" name="email" type="text" v-model="form.email" :placeholder="$t('email')"
                      v-if="control.Fields.Email" />
                    <span class="input-error" v-if="control.Fields.Email">{{ errors.email }}</span>



                    <label for="phone" class="text-capitalize" v-if="control.Fields.Phone">
                      {{ $t('telefono') }}{{ control.Fields.ForcePhone ? ' *' : '' }}</label>
                    <input id="phone" name="phone" v-if="control.Fields.Phone" type="text" rules="required"
                      v-model="form.phone" :placeholder="$t('telefono')" />
                    <span class="input-error" v-if="control.Fields.Phone">{{ errors.phone }}</span>



                    <label for="subject" class="text-capitalize" v-if="control.Fields.Subject">
                      {{ $t('asunto') }}{{ control.Fields.ForceSubject ? ' *' : '' }}</label>
                    <input id="subject" name="subject" v-if="control.Fields.Subject" type="text"
                      v-model="form.subject" :placeholder="$t('asunto')" />
                    <span class="input-error" v-if="control.Fields.Subject">{{ errors.subject }}</span>



                    <label for="message" class="text-capitalize" v-if="control.Fields.Message">
                      {{ $t('mensaje') }}{{ control.Fields.ForceMessage ? ' *' : '' }}</label>
                    <textarea id="message" name="message" v-if="control.Fields.Message" v-model="form.message"
                      :placeholder="$t('mensaje')"></textarea>
                    <span class="input-error" v-if="control.Fields.Message">{{ errors.message }}</span>


                    <div class="content check-pd">
                      <input type="checkbox" v-model="checkboxpd" name="pd" id="pd" class="ma-2"/>
                      <label for="pd" class="ma-1">{{ $t('aceptoDatos') }}<NuxtLink  class="ma-2" :to="'/protecciondatos'">{{ $t('aqui') }}</NuxtLink></label>
                    </div>
                    <div class="input-error">{{ errors.pd }}</div>
                    <!-- <v-checkbox v-model="aceptoPD"> He leido y acepto la <NuxtLink :to="'/protecciondatos'">Política de protección de datos</NuxtLink></v-checkbox>
                   -->
                  </div>

                </fieldset>

              </form>
              <div class="div-button">
                <v-btn class="rn-button-style-notin-1 button-form-notin  " type="submit" @click="handleSubmit"
                  :loading="sending" v-if="!enviado"
                  :aria-label="control.Button.Texto" :title="control.Button.Texto">
                  {{ control.Button.Texto }}
                </v-btn>
              </div>
              <div v-if="enviado" class="success-message-modern">
                <div class="success-icon-container">
                  <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                    <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                    <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                  </svg>
                </div>
                <h3 class="success-title">{{ $t('emailSuccessTitle') }}</h3>
                <p class="success-text">{{ $t('emailEnviado') }}</p>
                <p class="success-subtext">{{ $t('emailSuccessSubtext') }}</p>
              </div>
              <div v-if="enviado === false" class="error-message-modern">
                <v-icon color="error" size="32" class="mb-2">mdi-alert-circle-outline</v-icon>
                <div v-if="store.NOTARIA?.Contacto?.Email">
                  <p class="mb-0">{{ $t('emailErrorWriteTo') }}
                    <a :href="'mailto:' + store.NOTARIA.Contacto.Email" class="error-inline-link">
                      {{ store.NOTARIA.Contacto.Email }}
                    </a>
                  </p>
                </div>
                <div v-else-if="store.NOTARIA?.Contacto?.Telefono">
                  <p class="mb-0">{{ $t('emailErrorCallTo') }}
                    <a :href="'tel:' + store.NOTARIA.Contacto.Telefono" class="error-inline-link">
                      {{ store.NOTARIA.Contacto.Telefono }}
                    </a>
                  </p>
                </div>
                <p v-else class="mb-0">{{ $t('emailError') }}</p>
              </div>
              <div v-if="lockEmail" class="error-message-modern">
                <v-icon color="error" size="32" class="mb-2">mdi-lock-clock</v-icon>
                <p>{{ $t('lockEmail') }}</p>
              </div>
            </div>
          </v-col>
          <v-col lg="6" md="6" sm="12" cols="12" :order="control.ImagenPosicion === 1 ? 1 : 2">
            <div class="thumbnail mb_md--40 mb_sm--40">
              <img
                :src="control.Imagen ? imagenIDtoSRC(control.Imagen) : '~@/assets/images/about/about-6.jpg'"
                alt="Fotografia asociada al formulario de contacto" />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted, computed} from 'vue'
import nuxtStorage from 'nuxt-storage';
import { useStore } from '../../store/index'
const store = useStore()
const { NOTARIA } = storeToRefs(store)

import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()
import { VueReCaptcha, useReCaptcha } from 'vue-recaptcha-v3';
const { vueApp } = useNuxtApp();



const props = defineProps({
  contactForm: {
    type: Object,
    required: true
  }
})
const control = props.contactForm
//console.log("control form: ", control)
const actionName = 'email'
const sending = ref(false)
const enviado = ref(null)
const lockEmail = ref(null)
const checkboxpd = ref(null)
const form = ref({
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
  recaptcha: {
    id_credential: store.NOTARIA.Personalizar.RecaptchaGroup,
    token: "",
    action: actionName
  }
})
const errors = ref([])
async function created() {
  var lastEnviado = typeof window !== 'undefined' ? nuxtStorage.localStorage.getData('enviado'):null
  if (lastEnviado != null) {
    var diferencia = (new Date()).getTime() - lastEnviado
    if (diferencia > 1 * 60 * 1000) {//1 minuto
      enviado.value = false
      lockEmail.value = false
    } else {
      enviado.value = true
      lockEmail.value = true
    }
  }
}
//watch(()=>control, (n) => form.value = n, { deep: true })


//Init recaptcha
vueApp.use(VueReCaptcha, {
  siteKey: store.recaptchaSiteKey,
  loaderOptions: {
    autoHideBadge: false,
  },
});
async function mounted() {
  const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();
  await recaptchaLoaded();
  form.value.recaptcha.token = await executeRecaptcha(actionName);
}
onMounted(() => {
  mounted()
})

const compErrorEmail = computed(()=> {
  debugger
  if(enviado.value === false){
    return true
  }
  return false
})

async function handleSubmit(e) {
  if (e) e.preventDefault();
  if (form.value) {//&& form.token
    sending.value = true;
    if (checkForm()) {
      var result = await sendMail(form.value);
      enviado.value = result == "" ? true : false;
      if (enviado.value) {
        nuxtStorage.localStorage.setData('enviado', (new Date()).getTime());
        // var IdEmail
        // if(!NOTARIA.Emails){
        //   NOTARIA.Emails = []
        //   IdEmail=0
        // }else{
        //   IdEmail
        // }
        // var emailModel={

        // }
        // NOTARIA.Emails.push(emailModel)

        resetForm()
      } else {
        await mounted()
      }
    }
    sending.value = false;
    if (e) e.preventDefault()

  }

}
function resetForm() {
  form.value = {
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    recaptcha: {
      id_credential: store.NOTARIA.Personalizar.RecaptchaGroup,
      token: "",
      action: actionName
    }

  }
}
function checkForm() {
  errors.value = { name: "", email: "", phone: "", subject: "", message: "", pd: "" }
  var valid = true
  if (control.Fields.Name && control.Fields.ForceName && !form.value.name) {
    errors.value.name = $t('errorNombre')
    valid = false
  }
  if (control.Fields.Email) {
    if (control.Fields.ForceEmail && (!form.value.email || form.value.email.length < 5)) {
      errors.value.email = $t('errorEmailReq')
      valid = false
    } else if (form.value.email && !validEmail(form.value.email)) {
      errors.value.email = $t('errorEmailValido')
      valid = false
    }
  }
  if (control.Fields.Phone && control.Fields.ForcePhone && !form.value.phone) {
    errors.value.phone = $t('errorTelefono')
    valid = false
  }
  if (control.Fields.Subject && control.Fields.ForceSubject && !form.value.subject) {
    errors.value.subject = $t('errorAsunto')
    valid = false
  }
  if (control.Fields.Message && control.Fields.ForceMessage && !form.value.message) {
    errors.value.message = $t('errorMensaje')
    valid = false
  }
  if (!checkboxpd.value) {
    errors.value.pd = $t('errorPd')
    valid = false
  }


  return valid;


}
function validEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

async function sendMail(formData: any) {
  var cuerpo = "Mensaje enviado desde la web: " + location.origin + "<br><br>";
  cuerpo = cuerpo + "<b>ATENCIÓN:</b> Haga click sobre la dirección de correo de contacto para responder al remitente.<br><br>";
  if (formData.name != "")
    cuerpo = cuerpo + "Remitente: " + formData.name + "<br><br>";
  if (formData.email != "")
    cuerpo = cuerpo + 'Correo de contacto: <a href="mailto:' + formData.email + '">' + formData.email + '</a>' + "<br><br>";
  if (formData.phone != "")
    cuerpo = cuerpo + "Teléfono: " + formData.phone + "<br><br>";
  if (formData.asunto != "")
    cuerpo = cuerpo + "Asunto: " + formData.subject + "<br><br>";
  if (formData.message)
    cuerpo = cuerpo + "Mensaje: " + formData.message + "<br><br>";

  cuerpo = cuerpo + "<br><br><br><b>Por favor, no responda a este correo. Este mensaje ha sido generado automáticamente y no está configurado para recibir respuestas.</b>"

  const finalSubject = formData.subject || "Consulta General";
  const mailSubject = `Contacto WEB - ${store.NOTARIA.Nombre} - ${formData.name} - ${finalSubject} - FORM`;

  var model = {
    "perfil": "info_recaptcha_web_notaria",
    //"perfil": "info_recaptcha_web_notaria",
    "cuerpo": cuerpo,
    "is_cuerpo_html": true,
    "asunto": mailSubject,
    "destinatarios": [{ "nombre": store.NOTARIA.Nombre, "direccion": store.NOTARIA.Contacto.Email }],//
    "destinatarios_cco": [{ "nombre": "webNotin", "direccion": "web@notin.net" }],
    "recaptcha": formData.recaptcha,
    "data":{
        id_notaria: store.NOTARIA.id,
        Fecha: new Date().getTime().toString(),
        Name: formData.name,
        Email: formData.email,
        Phone: formData.phone,
        Subject: mailSubject,
        Message: formData.message
    }
    //"destinatarios": [{"nombre": "Web Notin", "direccion": "modelos@notin.net"}],
    //"destinatarios_cco": [{"nombre": "Web Notin", "direccion": "modelos@notin.net"}],
    //"destinatarios": [{"nombre": store.NOTARIA.Nombre, "direccion": 'modelos@notin.net'}],
    // "adjuntos": [
    //     {"nombre": "hola.txt", "contenido": "aG9sYSBhIHRvZG9zIGFtaWdvcyBkZWwgbXVuZG8gbXVuZGlhbA=="}
    // ]
  }
  var mail_service = ""
  // if (process.env.NODE_ENV == "development") {
  //   mail_service = 'http://localhost:3500/api/email'
  // }
  // else {
  //   mail_service = 'https://mailing.notin.es/api/email';
  // }
  mail_service = 'https://mailing.notin.es/api/email';
  try {
    let res: any = await $fetch(mail_service, { method: "POST", body: model, headers: { 'Content-Type': 'application/json' } })
    // if (res == "") {
    //   //enviamos copia de email a
    //   model.destinatarios = [{ "nombre": "webNotin", "direccion": "web@notin.net" }],//modelos@notin.net
    //     res = await $fetch(mail_service,{method:"post", body:model, headers: { 'Content-Type': 'application/json' } })
    // }
    return res;
  } catch (e) {
    console.error("Error de envío de formulario: problema de reCAPTCHA", e);
    return "error";
  }
}

const estiloTituloColor = ref(control.Titulo.css.Color)
const estiloTituloBackgroundColor = ref(control.Titulo.css.BackgroundColor)
const estiloTituloFont = ref(control.Titulo.css.Font)
const estiloTituloSize = ref(control.Titulo.css.Size)
const estiloTituloWeight = ref(control.Titulo.css.Weight)
const estiloTituloAlign = ref(control.Titulo.css.Align)

const estiloDescripcionColor = ref(control.Descripcion.css.Color)
const estiloDescripcionBackgroundColor = ref(control.Descripcion.css.BackgroundColor)
const estiloDescripcionFont = ref(control.Descripcion.css.Font)
const estiloDescripcionSize = ref(control.Descripcion.css.Size)
const estiloDescripcionWeight = ref(control.Descripcion.css.Weight)
const estiloDescripcionAlign = ref(control.Descripcion.css.Align)

const estiloButtonColor = ref(control.Button.css.Color)
const estiloButtonBackgroundColor = ref(control.Button.css.BackgroundColor)
const estiloButtonFont = ref(control.Button.css.Font)
const estiloButtonSize = ref(control.Button.css.Size)
const estiloButtonWeight = ref(control.Button.css.Weight)
const estiloButtonAlign = ref(control.Button.css.Align)
const borderButton = ref(control.Button.css.Color??  "2px solid" + control.Button.css.Color )
created()
console.log("css: " + estiloButtonColor.value)
</script>
<style lang="scss">
.titulo-form-notin h2 {
  color: v-bind(estiloTituloColor)!important;
  //background-color:v-bind(estiloTituloBackgroundColor) ;
  text-shadow: 4px 2px 6px v-bind(estiloTituloBackgroundColor)!important;
  font-family: v-bind(estiloTituloFont)!important;
  font-size: v-bind(estiloTituloSize) !important;
  font-weight: v-bind(estiloTituloWeight) !important;
  text-align: v-bind(estiloTituloAlign)!important;
}

.titulo-form-notin p {
  color: v-bind(estiloDescripcionColor) !important;
  //background-color:v-bind(estiloDescripcionBackgroundColor) ;
  text-shadow: 4px 2px 6px v-bind(estiloDescripcionBackgroundColor)!important;
  font-family: v-bind(estiloDescripcionFont)!important;
  font-size:v-bind(estiloDescripcionSize)!important;
  font-weight: v-bind(estiloDescripcionWeight)!important;
  text-align: v-bind(estiloDescripcionAlign)!important;
}
.div-button{
    text-align:v-bind(estiloButtonAlign) !important;
}
.button-form-notin {
  color: v-bind(estiloButtonColor) !important;
  background-color: v-bind(estiloButtonBackgroundColor) !important;
  font-family: v-bind(estiloButtonFont) !important;
  font-size:v-bind(estiloButtonSize);
  font-weight: v-bind(estiloButtonWeight) !important;

  border: v-bind(borderButton) !important;
}

.fields-form-notin input,
.fields-form-notin textarea {
  border: 2px solid v-bind(estiloButtonBackgroundColor) !important;
  background-color: #ffffff !important;
  border-radius: 8px;
  padding: 12px 15px;
  width: 100%;
  margin-bottom: 15px;
  outline: none;
  transition: all 0.3s ease;
}

.fields-form-notin input:focus,
.fields-form-notin textarea:focus {
  border-color: v-bind(estiloButtonBackgroundColor) !important;
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.05);
}

.fields-form-notin {
  color: v-bind(estiloButtonColor) !important;
  //background-color:v-bind(estiloTitulo.BackgroundColor) ;
  //text-shadow: 4px 2px 6px v-bind(estiloButtonBackgroundColor) ;
  font-family: v-bind(estiloButtonFont) !important;
  //font-size:v-bind(estiloSubtituloSize) ;
  font-weight: v-bind(estiloButtonWeight) !important;
  //text-align:v-bind(estiloSubtituloAlign);
}

.fields-form-notin label {
  color: v-bind(estiloButtonBackgroundColor) !important;
  //background-color:v-bind(estiloTitulo.BackgroundColor) ;
  font-family: v-bind(estiloButtonFont) !important;
  //font-size: 15px;
  //font-size:v-bind(estiloSubtituloSize) ;
  font-weight: v-bind(estiloButtonWeight) !important;
  //text-align:v-bind(estiloSubtituloAlign);
}

.check-pd {
  input {
    width: 20px;
    height: 20px;
  }
  label {
    //color: #283593FF;
    color: v-bind(estiloTituloColor);
    font-size: 20px;
    display: inline !important;
    margin-left: 4px;
  }

  a {
    color: v-bind(estiloTituloColor);
    text-decoration: underline !important;
  }
}

.success-message-modern {
  text-align: center;
  padding: 40px 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  animation: fadeIn 0.5s ease-out;
  border: 1px solid v-bind(estiloButtonBackgroundColor);
}

.error-message-modern {
  text-align: center;
  padding: 30px 20px;
  background: rgba(255, 235, 238, 0.9);
  border-radius: 16px;
  border: 1px solid rgba(244, 67, 54, 0.2);
  color: #d32f2f;
  animation: fadeIn 0.5s ease-out;
  margin-top: 20px;
}

.error-inline-link {
  color: inherit !important;
  text-decoration: underline !important;
  font-weight: bold;
  transition: opacity 0.2s ease;
}

.error-inline-link:hover {
  opacity: 0.8;
}

.success-icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: v-bind(estiloButtonBackgroundColor);
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 0 auto;
  box-shadow: inset 0px 0px 0px v-bind(estiloButtonBackgroundColor);
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% { stroke-dashoffset: 0; }
}
@keyframes scale {
  0%, 100% { transform: none; }
  50% { transform: scale3d(1.1, 1.1, 1); }
}
@keyframes fill {
  100% { box-shadow: inset 0px 0px 0px 50px v-bind(estiloButtonBackgroundColor); }
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.success-title {
  font-size: 24px;
  font-weight: v-bind(estiloTituloWeight);
  color: v-bind(estiloTituloColor);
  font-family: v-bind(estiloTituloFont);
  margin-bottom: 10px;
}

.success-text {
  font-size: 16px;
  color: v-bind(estiloDescripcionColor);
  font-family: v-bind(estiloDescripcionFont);
  font-weight: 600;
  margin-bottom: 5px;
}

.success-subtext {
  font-size: 14px;
  color: v-bind(estiloDescripcionColor);
  font-family: v-bind(estiloDescripcionFont);
  opacity: 0.8;
}
</style>
